<template>
  <b-container>
    <b-row>
      <b-col>
        <h1>{{ $t('Detailed Report') }}
          <b-link :to="{ name: 'Reports' }">
            <b-icon-arrow-return-left/>
          </b-link>
        </h1>
        <b-breadcrumb :items="br_items"/>
        <h2>
          {{ repr }}
          <b-link @click="show_modal  = true">
            <b-icon-gear/>
          </b-link>
          <a :href="build_url(true, true)">
            <b-icon-download/>
          </a>
        </h2>
        <b-modal hide-header hide-footer v-model="show_modal">
          <h-c-d-report-form @ok="go_to"/>
        </b-modal>
      </b-col>
    </b-row>
    <b-overlay :show="loading">
      <b-row v-for="(quiz, i) in resp" :key="i">
        <b-col>
          <b-table-simple>
            <colgroup>
              <col/>
              <col/>
              <col/>
            </colgroup>
            <col/>
            <col/>
            <b-tr class="blue-bg">
              <th colspan="5">{{ category ? category.name : 'Undef' }}</th>
            </b-tr>
            <b-tr class="lightblue-bg">
              <th colspan="2">{{ get_info_type_from_quiz(quiz, 'line') }}</th>
              <th>{{ $t('Operator') }}: {{ get_person_name(quiz) }}</th>
              <th>{{ $t('Date') }}: {{ quiz.date|date_format }} </th>
              <th>{{ $t('Controller') }} {{ get_person_name(quiz, 'person') }}</th>
            </b-tr>
            <b-tr class="green-bg">
              <th>№</th>
              <th colspan="2">{{ $t('DMS key element') }}</th>
              <th>{{ $t('Score') }}</th>
              <th>{{ $t('Comment') }}</th>
            </b-tr>
            <b-tr v-for="(answer) in sortAnswers(quiz.answers)" :key="answer.pk">
              <b-td class="lightgreen-bg">{{ answer.order }}</b-td>
              <b-td colspan="2">{{ get_name(answer) }}</b-td>
              <b-td>{{ answer.value |human_value }}</b-td>
              <b-td>{{ answer.commentary }}</b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="3">{{ $t('Total') }}</b-td>
              <b-td class="nowrap">{{ (quiz.p_score * 100).toFixed(1) }} %</b-td>
              <b-td></b-td>
            </b-tr>
            <b-tr class="orange-bg" v-if="quiz.answers.filter(a=>a.action).length">
              <b-th colspan="3">{{ $t('Action Step') }}</b-th>
              <b-th>{{ $t('Deadline') }}</b-th>
              <b-th>{{ $t('Owner') }}</b-th>
            </b-tr>
            <b-tr class='lightpink-bg' v-for="answer in quiz.answers.filter(a=>a.action)" :key="answer.pk">
              <b-td colspan="3">{{ answer.action }}</b-td>
              <b-td>{{ answer.deadline|date_format }}
              </b-td>
              <b-td>{{ info_name(answer.owner) }}</b-td>
            </b-tr>
          </b-table-simple>
        </b-col>
      </b-row>
      <b-row v-if="is_empty">
        <h2>{{ $t('Nothing found') }}</h2>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import {orderBy} from 'lodash-es'
import {dict_to_search, to_query, date_format} from "../shared";
import HCDReportForm from "../components/HCDReport";
import {SERVER} from "../constants";
import { isEqual } from 'lodash';


export default {
  name: "HCDReport",
  components: {HCDReportForm},
  props: {
    person_id: {
      type: Number,
      required: false
    },
    operator_id: {
      type: Number,
      required: false
    },
    line_id: {
      type: Number,
      required: false
    },
    category_id: {
      type: Number,
      required: false,
    },
    date: {
      type: String,
      required: true
    }
  },
  filters: {
    date_format,
    human_value: value => {
      let ret = '-'
      if (value === true) {
        ret = '1';
      } else if (value === false) {
        ret = '0'
      }
      return ret
    },

  },
  mounted() {
    this.load()
    this.$watch(
      () => JSON.stringify([this.category_id, this.person_id, this.operator_id, this.line_id, this.date]),
      this.load
    )
  },
  data() {
    return {
      resp: [],
      loading: false,
      show_modal: false,
      is_same: false
    }
  },
  computed: {
    br_items() {
      return [
        {text: this.$t('Home'), to: {name: 'Home'}},
        {text: this.$t('Reports'), to: {name: "Reports"}},
        {text: this.$t('HCD Report'), active: true}
      ]
    },
    ...['person', 'operator', 'line', 'cell'].reduce((r, key) => {
      function getter() {
        return this.$store.getters[key].reduce((r1, item) => ({...r1, [item.pk]: item}), {})
      }

      r[key] = getter
      return r
    }, {}),
    repr() {
      let ret = []
      
      if (this.category_id) {
        let c = this.$store.getters.category.find(o => o.pk == this.category_id)
        if (c) {
          ret.push(c.name)
        }
      } else {
        ret.push(this.$t('All categories'))
      }
      if (this.operator_id) {
        let c = this.$store.getters.additional_info.find(o => o.pk == this.operator_id)
        if (c) {
          ret.push(c.name)
        }
      }
      if (this.person_id) {
        let c = this.$store.getters.additional_info.find(o => o.pk == this.person_id)
        if (c) {
          ret.push(c.name)
        }
      }
      if (this.line_id) {
        let c = this.$store.getters.additional_info.find(o => o.pk == this.line_id)
        if (c) {
          ret.push(c.name)
        }
      }
      return ret.join(', ')
    },
    is_empty() {
      return this.resp.length == 0
    },
    category() {
      return this.$store.getters.category.find(c => c.pk === this.category_id)
    },

  },
  methods: {
    get_name(question, key = 'name') {
      const lang = this.$store.getters.lang || 'en';
      const value = question[key] || {};
      return value[lang] || value['en'] || value['ru'] || this.$t('Unknown')
    },
    get_info_type_from_quiz(quiz, type = 'line') {
      const info = quiz.info || []
      const obj = Object.values(this[type]).find(t => info.indexOf(t.pk) > -1) || {}
      return obj.name || '--'

    },
    build_to_query_params() {
      let q_data = {
        start: this.date,
        period: 'day'
      }
      for (const d of ['category', 'operator', 'person', 'line']) {
        if (this[`${d}_id`]) {
          q_data[d] = this[`${d}_id`]
        }
      }
      return q_data
    },
    build_url(xls = false, with_server = false) {
      let q_data = this.build_to_query_params()
      

      if (xls) {
        q_data['frmt'] = 'xlsx'
      }
      let query_str = dict_to_search(q_data);
      let ret = `api/reports/hcd/?${query_str}`
      if (with_server) {
        ret = `${SERVER}/${ret}`
      }
      return ret
    },
    reset_data() {
      this.resp = []
    },
    load() {
      this.loading = true
      this.reset_data()
      Promise.all([
        this.$store.dispatch('load_data', ['question', 'additional_info']),
        this.$store.dispatch("get", {
          url: this.build_url(),
        })
        .then((r) => {
          this.resp = r
        })
      ]).then(() => this.loading = false)
    },
    go_to(args) {
      this.show_modal = false
      this.$router.push({name: this.$route.name, query: to_query(args)})
      this.$$nextTick().then(() => {
        this.is_same = isEqual(this.build_to_query_params(), this.$route.query)
      } )
      this.load()
    },
    sortAnswers: answers => orderBy(answers, ['order']),
    info_name(pk) {
      let ret = '--'
      const info = this.$store.getters.additional_info.find(i => i.pk == pk)
      if (info) {
        ret = info.name
      }
      return ret
    },
    get_person_name(quiz, type = 'operator') {
      const infos = this.$store.getters.additional_info.filter(i => quiz.info.indexOf(i.pk) >= 0)
      const person = infos.find(i => i.type === type)
      return person ? person.name : '--'
    }
  },
}
</script>

<style scoped>

</style>
